import dayjs from 'dayjs'

import { type NotificationItem } from '@/lib/queries/notification/v1/history/types'
import { cn } from '@/lib/utils'

import { getMessageIconAndTitle } from '../../../utils'

export interface UpdateItemProps {
  data: NotificationItem
}

export const GeneralUpdateItem = ({ data }: UpdateItemProps) => {
  const { messageType, message, createdAt } = data

  const { icon, title } = getMessageIconAndTitle(messageType)

  return (
    <div className={cn('flex items-center', 'border-b border-[#e4e4e7]', 'px-[18px] py-[12px]')}>
      <div className={cn('flex self-start')}>
        <img src={icon} alt={`Notification icon for ${title}`} />
      </div>

      <div className={cn('flex-1', 'mx-2.5', 'text-foreground', 'space-y-1')}>
        <p className={cn('text-sm font-normal leading-[30px]')}>{title}</p>
        <p className={cn('text-base font-normal leading-[30px]')}>{message}</p>
      </div>

      <div className={cn('self-start')}>
        <p className={cn('text-right text-sm font-normal leading-[30px] text-foreground')}>
          {dayjs.utc(createdAt).format('MM/DD/YYYY')}
        </p>
      </div>
    </div>
  )
}
